<div class="d-flex align-items-center">
    <input
        type="checkbox"
        id="hubspot-sandbox-toggle"
        class="mr-2"
        [ngModel]="sandbox.checked"
        (ngModelChange)="sandbox.toggle($event)"
        data-testid="hubspot-sandbox-toggle-use-sandbox"/>
    <label class="mb-0 mr-3" for="hubspot-sandbox-toggle">Use HubSpot sandbox portal</label>
    <span class="badge" [ngClass]="sandbox.useSandbox ? 'badge-success' : 'badge-danger'">
        {{ sandbox.useSandbox ? 'SANDBOX' : 'PRODUCTION' }}
    </span>
</div>



// WEBPACK FOOTER //
// ./src/app/developer/components/hubspot-sandbox-toggle/hubspot-sandbox-toggle.component.html